import produce from 'immer'
import * as types from '../constants/FeedfilterActionTypes'

const initialState = {
	rules: {
		'operation': 'and',
		'scope': '$',
		'children': []
	}
}

function setRules(state, rules){
    return produce(state, draft => {
        console.log('Rules', rules);
        if(rules === null)
            draft.rules = initialState.rules;
        else
            draft.rules = rules;
    });
}

function updateRule(state, path, update){
    return produce(state, draft => {
        draft['rules'];

        let rule = draft['rules'];
        for(let key of path)
            rule = rule[key];

        for(let key in update){
            if(typeof update[key] === 'undefined'){
                if(typeof rule[key] !== 'undefined')
                    delete rule[key];
            }else
                rule[key] = update[key];
        }
	});
}

function addRule(state, path, scope){
    return produce(state, draft => {
        let rules = draft.rules;

        let rule = {
            operation: 'rule',
            key: 'ID',
            scope: (typeof scope === 'undefined')?null:scope,
            mode: 'is',
            values: []
        };

        let parent = rules;
        for(let key of path)
            parent = parent[key];

        /*for(let key in update){
            if(key === 'values')
                rule[key] = update[key]
            else
                rule = rule[key] = update[key];
        }*/

        parent.children.push(rule);

        /*let parent = rules.getIn(path);
        let children = parent.get('children');
        children = children.push(rule);
        parent = parent.set('children', children);
        rules = rules.setIn(path, parent);
        return state.set('rules', rules);**/
    })
}

function addConjunction(state, path, operation, scope){
    return produce(state, draft => {
        let rules = draft.rules;

        let conjunction = {
            operation: operation,
            scope: (typeof scope === 'undefined')?null:scope,
            children: []
        };

        let parent = rules;
        for(let key of path)
            parent = parent[key];

        parent.children.push(conjunction);

    })

	/*let rules = state.get('rules');
	let conjunction = new Immutable.Map({
		operation: operation,
		scope: scope,
		children: new Immutable.List()
	});
	
	let parent = rules.getIn(path);
	let children = parent.get('children');
	children = children.push(conjunction);
	parent = parent.set('children', children);
	rules = rules.setIn(path, parent);
	return state.set('rules', rules);*/	
}

function removeNode(state, path){
    return produce(state, draft => {
        let rules = draft.rules;

        let parent = rules;
        while(path.length > 1){
            let key = path.shift();
            parent = parent[key];
        }

        let key = path.shift();
        delete parent[key];

    })
	/*let rules = state.get('rules');	
	rules = rules.removeIn(path);
	return state.set('rules', rules);*/
}

export default function feedfilter (state = initialState, action) {
  switch (action.type) {
  	case types.UPDATE_RULE:
  		return updateRule(state, action.path, action.update);
  	case types.ADD_CONJUNCTION:
  		return addConjunction(state, action.path, action.conjunction, action.scope);
  	case types.ADD_RULE:
  		return addRule(state, action.path, action.scope);
  	case types.REMOVE_NODE:
  		return removeNode(state, action.path);
  	case types.SET_RULES:
  		return setRules(state, action.rules);
    default:
      return state;
  }
}
